"use client";

import { SupabaseAuthProvider } from "./supabase-auth-provider";
import { ReactQueryProvider } from "./reactQueryProvider";

interface AuthProvidersProps {
  children: React.ReactNode;
}

export function AuthProviders({ children }: AuthProvidersProps) {
  return (
    <SupabaseAuthProvider>
      <ReactQueryProvider>
        {children}
      </ReactQueryProvider>
    </SupabaseAuthProvider>
  );
}
